import { Typography, TypographyProps } from '@cfa/react-components';

import { cn } from '@/utils/tailwind';

const PlanCardLabel: React.FC<TypographyProps> = ({
  children,
  className,
  ...props
}) => (
  <Typography
    data-testid={'PlanCardLabel'}
    variant="overline3"
    className={cn(
      'max-w-full min-w-0 overflow-hidden wrap-break-word text-ellipsis',
      className,
    )}
    {...props}
  >
    {children}
  </Typography>
);

export default PlanCardLabel;
